var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data: function data() {
    return {
      item: {
        person: {
          full_name: ''
        },
        unit: {
          name: ''
        },
        property: {
          name: ''
        },
        n_s_f_payment_meta: {
          current_auth_level_code: '',
          current_auth_level_message: ''
        }
      },
      isBlacklisted: false,
      isUserExist: false,
      residentId: 0,
      show: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on('refresh-resident-dashboard', function (resident) {
      Event.$emit('reset-resident-tabs'); // On ResidentTabs.vue
      // this.show = true;
      if (resident) {
        _this.residentId = resident.id;
        _this.getResident();
      }
    });

    Event.$on('reload-resident', function () {
      _this.getResident();
    });

    Event.$on('check-blacklist', this.checkBlacklist);
    Event.$on('close-resident-dashboard', function () {
      _this.close();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off('check-blacklist');
    Event.$off('refresh-resident-dashboard');
    Event.$off('close-resident-dashboard');
    Event.$off('reload-resident');
  },

  methods: {
    getActiveLease: function getActiveLease(leases) {
      if (leases.length === 0) return null;

      // look for first active, or else first lease
      var activeLeaseIndex = leases.findIndex(function (e) {
        return e.is_active === 1;
      });
      if (activeLeaseIndex > -1) {
        console.log('found active ' + activeLeaseIndex);
        return leases[activeLeaseIndex];
      }
      return leases[0];
    },
    getResident: function getResident() {
      var _this2 = this;

      window.axios.get('/prototype/resident/' + this.residentId).then(function (response) {
        _this2.item = _extends({}, response.data);
        _this2.checkBlacklist();
      }).then(function () {
        _this2.item.lease = _this2.getActiveLease(_this2.item.leases);
      }).then(function () {
        _this2.show = true;
      });
    },
    checkBlacklist: function checkBlacklist() {
      var _this3 = this;

      var payload = {
        resident: this.residentId
      };

      window.axios.post('/prototype/person/resident/check-blacklist', payload).then(function (response) {
        _this3.isBlacklisted = response.data && Object.entries(response.data).length > 0;
      });

      window.axios.post('/prototype/resident/check-user-exist', payload).then(function (response) {
        _this3.isUserExist = response.data ? response.data.is_user_exist : false;
      });
    },
    close: function close() {
      this.show = false;
      Event.$emit('close-full-modal');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentDashboard.vue
// module id = tSoV
// module chunks = 0 1